import React, { useState, useLayoutEffect, useEffect } from "react";
import usePrevious from "../hooks/usePrevious";
import calculateBoundingBoxes from "../helper/calculateBoundingBox";

const AnimateBed = ({ children }) => {
    const [boundingBox, setBoundingBox] = useState({});
    const [prevBoundingBox, setPrevBoundingBox] = useState({});
    const prevChildren = usePrevious(children);

    useLayoutEffect(() => {
        const newBoundingBox = calculateBoundingBoxes(children);
        setBoundingBox(newBoundingBox);
    }, [children]);

    useLayoutEffect(() => {
        const prevBoundingBox = calculateBoundingBoxes(prevChildren);
        setPrevBoundingBox(prevBoundingBox);
    }, [prevChildren]);

    useEffect(() => {
        const hasPrevBoundingBox = Object.keys(prevBoundingBox).length;

        if (!hasPrevBoundingBox) return;

        const deltas = [];
        React.Children.forEach(children, child => {
            const domNode = child && child.ref && child.ref.current;
            if (!domNode) return;

            const firstBox = prevBoundingBox[child.key];
            const lastBox = boundingBox[child.key];
            if (!firstBox || !lastBox) return;

            const changeInX = firstBox.left - lastBox.left;
            const changeInY = firstBox.top - lastBox.top;
            if (changeInX || changeInY) {
                deltas.push({ child, domNode, changeInX, changeInY });
            }
        });

        if (deltas.length === 0) return;

        // Same shift on every card = scroll or container moved, not reorder — skip FLIP
        if (deltas.length >= 2) {
            const { changeInX: refX, changeInY: refY } = deltas[0];
            const uniformShift = deltas.every(
                (d) => d.changeInX === refX && d.changeInY === refY
            );
            if (uniformShift) return;
        }

        deltas.forEach(({ domNode, changeInX, changeInY }) => {
            requestAnimationFrame(() => {
                if (changeInX) domNode.style.transform = `translateX(${changeInX}px)`;
                else if (changeInY) domNode.style.transform = `translateY(${changeInY}px)`;

                domNode.style.transition = "transform 0s";

                requestAnimationFrame(() => {
                    domNode.style.transform = "";
                    domNode.style.transition = "transform 500ms";
                });
            });
        });
    }, [boundingBox, prevBoundingBox, children]);

    return children;
};

export default AnimateBed;
